import { Recipient } from 'types';

const DATE_PATTERN = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;

const DATE_QUERY_KEYS = ['modifiedStart', 'modifiedEnd'];

const FILTER_CLASSIFICATIONS = {
  change: {
    value: 'Change',
  },
  incident: {
    value: 'Incident',
  },
  serviceRequest: {
    value: 'Service Request',
  },
};

const FILTER_SEVERITIES = {
  low: {
    value: 'low',
  },
  normal: {
    value: 'Normal',
  },
  high: {
    value: 'High',
  },
  urgent: {
    value: 'Urgent',
  },
};

const SORT_BY_VALUES = [
  {
    key: 'subject',
    name: 'Subject',
  },
  {
    key: 'status',
    name: 'Status',
  },
  {
    key: 'lastModified',
    name: 'Last Modified',
  },
  {
    key: 'oldestModified',
    name: 'Oldest Modified',
  },
  {
    key: 'ticketIdAscending',
    name: 'Ticket ID Ascending',
  },
  {
    key: 'ticketIdDescending',
    name: 'Ticket ID Descending',
  },
];

const TICKET_TYPE_VALUES = [
  {
    key: 'private',
    name: 'Private',
  },
  {
    key: 'public',
    name: 'Public',
  },
];

const SORTING_KEYS = {
  MODIFIED: 'modified',
  TICKET_ID: 'ticketId',
  SUBJECT: 'subject',
  STATUS: 'status',
  ASCENDING: 'ASC',
  DESCENDING: 'DESC',
};

const TICKET_TYPES = {
  PRIVATE: 'private',
  PUBLIC: 'public',
};

const RACKSPACE_DAY_ONE = '1998-01-01';

const TICKET_ID_REGEX = /^#?\d{6,8}-\w{3}-\d{7,8}$/;

const TICKET_STATUS_MAP = {
  All: {
    label: 'All Tickets',
    name: 'All',
    order: 3,
    value: null,
    translationKey: 'All',
  },
  Closed: {
    label: 'Closed Tickets',
    name: 'Closed',
    order: 2,
    value: 'Closed',
    translationKey: 'Closed',
  },
  Open: {
    label: 'Open Tickets',
    name: 'Open',
    order: 0,
    value: 'Open',
    translationKey: 'Open',
  },
  'Pending Customer': {
    label: 'Pending Customer',
    name: 'Pending Customer',
    order: 1,
    value: 'Pending Customer',
    translationKey: 'PendingCustomer',
  },
};

const TICKET_STATUS_OPTIONS = Object.keys(TICKET_STATUS_MAP)
  .map((key) => TICKET_STATUS_MAP[key])
  .sort((a, b) => (a.order > b.order ? 1 : -1));

/*
 * Current ticket selection limit is 10.
 * But here we need to make it maxTicketSelect - 1 . Due to logic. 
 */
const SELECTED_TICKETS_LIMIT = 9;

/*
 * We have tickets created/modified by Racker.
 * We are adding CREATOR_IS_RACKER  manually in user list
 */
const CREATOR_IS_RACKER: Recipient = {
  fullName: 'Rackspace',
  id: 'racker',
  roles: ['Racker'],
  email: '',
  username: '',
  _isChecked: false,
  _isCreator: false,
  _isPrimary: false,
  _toRemove: false,
};
const EXCLUDED_EXPORT_TICKETS_STATUS = [TICKET_STATUS_MAP.All.name];

export {
  DATE_PATTERN,
  DATE_QUERY_KEYS,
  EXCLUDED_EXPORT_TICKETS_STATUS,
  FILTER_CLASSIFICATIONS,
  FILTER_SEVERITIES,
  RACKSPACE_DAY_ONE,
  TICKET_ID_REGEX,
  TICKET_STATUS_MAP,
  TICKET_STATUS_OPTIONS,
  SELECTED_TICKETS_LIMIT,
  CREATOR_IS_RACKER,
  SORT_BY_VALUES,
  SORTING_KEYS,
  TICKET_TYPE_VALUES,
  TICKET_TYPES,
};
